import { render, staticRenderFns } from "./DemoteButton.vue?vue&type=template&id=3994ded0&"
import script from "./DemoteButton.vue?vue&type=script&lang=js&"
export * from "./DemoteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports